import { render, staticRenderFns } from "./AdditionalCompaniesDatatable.vue?vue&type=template&id=3a1abfd3&"
import script from "./AdditionalCompaniesDatatable.vue?vue&type=script&lang=js&"
export * from "./AdditionalCompaniesDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports